import { render } from "./InactivityModal.vue?vue&type=template&id=1fa5929e&scoped=true"
import script from "./InactivityModal.vue?vue&type=script&lang=js"
export * from "./InactivityModal.vue?vue&type=script&lang=js"

import "./InactivityModal.vue?vue&type=style&index=0&id=1fa5929e&scoped=true&lang=css"

import exportComponent from "/Users/pedro-guzman/Documents/sherpa/sherpa_digital/microservices/sherpa_salud_digital_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa5929e"]])

export default __exports__